import { Box, Text } from "@chakra-ui/react";
import { FC, useEffect, useRef, useState } from "react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { hairTipsByType } from "../../configs/tips";
import { useHairTipsStyles } from "../../hooks/useHairTipsStyles";
import useScreen from "../../hooks/useScreen";

SwiperCore.use([Pagination]);

interface HairTipsCarouselProps {
  place: "small-loader" | "processing-image";
  vto?: string;
  color?: string;
}

export const HairTipsCarousel: FC<HairTipsCarouselProps> = (props) => {
  const [tips] = useState(hairTipsByType(props.vto || "all"));
  const { isMobile } = useScreen();
  const swiperRef = useRef<SwiperCore>();
  const { slideBoxStyle, slideHeaderTextStyle, slideDescriptionTextStyle } =
    useHairTipsStyles(props.place);

  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return '<span class="' + className + '">' + "</span>";
    },
  };

  useEffect(() => {
    const interval = setInterval(() => swiperRef.current?.slideNext(), 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Text
        align="center"
        fontSize={slideHeaderTextStyle.fontSize}
        fontWeight="bold"
        color={slideBoxStyle.color}
        mb={slideBoxStyle.gap}
      >
        Hair Tips for you
      </Text>

      <Swiper
        onInit={(core: SwiperCore) => (swiperRef.current = core)}
        spaceBetween={50}
        slidesPerView={1}
        allowTouchMove={isMobile ? true : false}
        pagination={isMobile ? true : pagination}
        modules={[Pagination]}
        loop={true}
        className={"swiper-from__" + props.place}
      >
        {tips.map((tip, index) => (
          <SwiperSlide key={index}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              color={slideBoxStyle.color}
              gap={slideBoxStyle.gap}
              px={slideBoxStyle.px}
              mt={slideBoxStyle.gap}
            >
              <Text
                maxWidth="400px"
                align="center"
                fontSize={slideDescriptionTextStyle.fontSize}
                lineHeight={slideDescriptionTextStyle.lineHeight}
                fontWeight={slideDescriptionTextStyle.fontWeight}
              >
                {tip.description}
              </Text>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};
